
import { defineComponent } from "vue";
import axios from "axios";
// import Heading from "@/components/Heading.vue";

export default defineComponent({
  name: "Home",
  mounted() {
    axios
      .get("https://covid-193.p.rapidapi.com/statistics", {
        headers: {
          "x-rapidapi-key":
            "3d441973b3msh022be63635ed551p19e279jsn9e3bd8a1b48d",
          "x-rapidapi-host": "covid-193.p.rapidapi.com",
        },
      })
      .then((res) => {
        // console.log(res.data.response);
        const unfiltered = res.data.response;
        this.listData = unfiltered;
        this.tempData = unfiltered;
      });
  },
  methods: {
    handleHugeNum(num: number) {
      let result;
      if (num > 1000_000_000) {
        result = `${Math.round((num / 1000_000_000) * 100) / 100}B`;
      } else if (num > 1000_000) {
        result = `${Math.round((num / 1000_000) * 100) / 100}M`;
      } else if (num > 1000) {
        result = `${Math.round((num / 1000) * 100) / 100}k`;
      } else if (num === null) {
        result = 0;
      } else {
        result = num;
      }
      return result;
    },
  },
  data() {
    return {
      listData: [],
      tempData: [],
      country: "",
    };
  },
  computed: {
    handleOnChange() {
      // @ts-ignore
      const filtered = this.listData.filter(
        (data: any) => data.country === this.country
      );
      console.log(this.country, typeof filtered);
      if (filtered.length > 0) {
        this.listData = filtered;
      } else {
        this.listData = this.tempData;
        // console.log("Get old data");
      }
    },
  },
});
